module.exports = __webpack_public_path__ + "img/button-bg.8761261.png";